import { Control } from "react-hook-form"
import { FormSelectInput } from "../FormSelectInput"

const ageGroupOptions = [
  { value: "adult", label: "Adult (over 18)" },
  { value: "child", label: "Child (2-17)" },
  { value: "infant", label: "Infant (under 2)" },
]

interface SelectAgeInputProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control: Control<any>
  name: string
  label: string
  parentBackgroundColor: string
  lightOutline?: boolean
  darkTheme?: boolean
}

const SelectAgeInput: React.FC<SelectAgeInputProps> = ({
  control,
  name,
  label,
  parentBackgroundColor,
  lightOutline,
  darkTheme,
}) => {
  return (
    <FormSelectInput
      name={name}
      options={ageGroupOptions}
      control={control}
      label={label}
      parentBackgroundColor={parentBackgroundColor}
      lightOutline={lightOutline}
      darkTheme={darkTheme}
    />
  )
}

export default SelectAgeInput
